import { postRequest } from "@react/helpers/fetch"

export const updateCategoryBudget = (projectId, body) =>
  postRequest({
    url:  `/projects/${projectId}/valorisation/update_budget.json`,
    body,
  })
